<template>
  <div style="margin-bottom: 10px">
    可选列：
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" class="check_all">
      全选
    </el-checkbox>
    <el-checkbox-group v-model="checkedCols" @change="handleCheckedChange">
      <draggable v-model="newCols">
        <el-checkbox v-for="(col,index) in newCols" :key="index" :label="col.title" style="margin-bottom: 5px">
          {{ col.title }}
        </el-checkbox>
      </draggable>
    </el-checkbox-group>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: "TableCol",
  props: ['cols', 'tableName'],
  components: {draggable},
  data() {
    return {
      isIndeterminate: false,
      checkAll: true,
      checkedCols: [],
      newCols: []
    }
  },
  watch: {
    cols: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          let cols = JSON.parse(JSON.stringify(newVal)) // 最新的值
          let tableCol = localStorage.getItem(this.tableName) // 获取localStorage的表格顺序

          // 1. 尝试解析本地存储的数据
          let storedConfig = null
          if (tableCol) {
            try {
              storedConfig = JSON.parse(tableCol)
            } catch (e) {
              console.error("解析localStorage数据失败:", e)
            }
          }

          // 2. 处理新增列逻辑
          if (storedConfig && storedConfig.order && storedConfig.order.length > 0) {
            const storedOrder = storedConfig.order

            // 分离：已存储的列 + 新增列
            const existingCols = []
            const newAddedCols = []

            cols.forEach(col => {
              if (storedOrder.includes(col.title)) {
                existingCols.push(col)
              } else {
                newAddedCols.push(col) // 识别新增列
              }
            })

            // 对已有列按存储顺序排序
            existingCols.sort((a, b) => {
              return storedOrder.indexOf(a.title) - storedOrder.indexOf(b.title)
            })

            // 合并：已有列(按原序) + 新增列(放在最后)
            const sortedCols = [...existingCols, ...newAddedCols]
            this.newCols = sortedCols

            // 3. 处理勾选状态：新增列自动勾选
            const storedChecked = storedConfig.checked || []
            const newColTitles = newAddedCols.map(col => col.title)

            // 合并勾选：原勾选 + 新增列
            const newChecked = [...storedChecked, ...newColTitles]
                .filter(title => cols.some(col => col.title === title)) // 过滤已删除列

            // 更新本地存储（包含新顺序和勾选状态）
            localStorage.setItem(this.tableName, JSON.stringify({
              order: sortedCols.map(item => item.title),
              checked: newChecked
            }))
          } else {
            // 无存储记录时，使用默认顺序
            this.newCols = cols
          }
        }
      },
      immediate: true
    },
    newCols: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          let tableCol = localStorage.getItem(this.tableName)
          let storedChecked = []

          if (tableCol) {
            try {
              const parsed = JSON.parse(tableCol)
              storedChecked = parsed.checked || []
            } catch (e) {
              console.error("解析localStorage数据失败:", e)
            }
          }
          // 设置勾选状态（优先使用存储值，无则全选）
          this.checkedCols = storedChecked.length > 0 ? storedChecked : newVal.map(item => item.title)
        }
      },
      immediate: true
    },
    checkedCols: {
      handler: function (newVal) {
        if (newVal) {
          // 更新本地存储
          localStorage.setItem(this.tableName, JSON.stringify({
            order: this.newCols.map(item => item.title),
            checked: newVal
          }))

          // 更新全选状态
          this.isIndeterminate = newVal.length > 0 && newVal.length < this.newCols.length
          this.checkAll = newVal.length === this.newCols.length

          this.submits()
        }
      },
      immediate: true
    },
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCols = val ? this.newCols.map(item => item.title) : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.newCols.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.newCols.length
    },
    submits() {
      if (this.checkedCols.length === 0) {
        this.$message.info('全不勾选时，列表默认全展示')
        return
      }
      this.$emit('submit', this.newCols, this.checkedCols)
    }
  }
}
</script>

<style scoped>
.check_all {
  margin-left: 5px;
  margin-bottom: 5px
}
</style>
